import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { makeGetUploadingFiles, makeGetProcessingFiles } from '../selectors/files';

import { reloadUploading } from '../actions/files';

import Alert from './alert';

import IconCheckCircled from '../icons/icon-check-circled';

class UploadingFilesAlert extends PureComponent {
    get message() {
        const { t } = this.props;
        const processing = this.processing;
        const progress = Math.round(this.progress * 100);
        const files = [...this.props.processingFiles, ...this.props.files];

        if (!files.length) {
            return '';
        }

        if (this.completed) {
            return t('upload.uploaded', { count: files.length });
        }

        return t(`upload.${processing ? 'processing' : 'uploading'}`, {
            count: files.length,
            name: (files[0].name || '').substring(0, 30),
            progress
        });
    }

    get processing() {
        return (this.progress === 1 || this.progress === 0);
    }

    get completed() {
        return !this.props.processingFiles.length && !this.props.files.some(file => !file.uploaded);
    }

    get progress() {
        if (!this.props.files.length)  {
            return 0;
        }

        return this.props.files.map(({ progress =  0 }) => progress).reduce((total, progress) => total + progress) / this.props.files.length;
    }

    componentDidUpdate() {
        if (this.props.files.length && !this.timer) {
            this.timer = setTimeout(() => {
                this.timer = null;
                reloadUploading();
            }, 1000);
        }
    }

    render() {
        if (!this.props.files.length && !this.props.processingFiles.length) {
            return null;
        }

        return (
            <Alert collapsed={!this.completed && !this.processing} progress={this.progress} type="success" icon={this.completed ? <IconCheckCircled /> : <i className="icon material-icons icon-animate-rotate">autorenew</i>}>
                { this.message }
            </Alert>
        )
    }
}

const makeMapStateToProps = () => {
    const getUploadingFiles = makeGetUploadingFiles();
    const getProcessingFiles = makeGetProcessingFiles();

    return ({ files }) => {
        return {
            processingFiles: getProcessingFiles(files.processing),
            files: getUploadingFiles(files.uploading)
            // files: [{
            //     progress: .5
            // }]
        }
    };
};

export default connect(makeMapStateToProps)(withTranslation('file')(UploadingFilesAlert));
